module.exports = __webpack_public_path__ + "static/img/69.570fda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/69.png
// module id = ytYQ
// module chunks = 1